export default __webpack_public_path__ + "static/media/gmail.c2f45e8f.svg";